import { Outlet } from 'react-router-dom'
import { ScrollTop } from '@/components/scroll-top'
import { SiteFooter } from '@/components/site-footer'
import { SiteHeader } from '@/components/site-header'
import { Separator } from '@/components/separator'

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1 max-w-screen overflow-x-hidden px-2">
        <div className="mx-auto md:max-w-360">
          <Separator height="h-4" />
          <div className="border-x border-edge" />
        </div>
        <Outlet />
      </main>
      <SiteFooter />
      <ScrollTop />
    </div>
  )
} 